<template lang="pug">
.preview
  v-card.text-center.py-4.px-12(outlined :class="previewClasses")
    slot
</template>

<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      default: 'neutral300'
    },
    borderRound: {
      type: String,
      default: 'xl'
    }
  },
  computed: {
    previewClasses() {
      return `${this.backgroundColor} round-${this.borderRound}`
    }
  },
}
</script>

<style scoped>
</style>